
export default function AreasSection() {
  const areas = [
    'Vic Centre Històric',
    'El Remei',
    'Horta Vermella',
    'Estadi',
    'Vic Sud',
    'Serra-de-senferm',
    'Caputxins',
    'Manlleu',
    'Torelló',
    'Taradell',
    'Tona',
    'Gurb',
    'Calldetenes',
    'Roda de Ter',
    'Folgueroles',
  ];

  return (
    <section className="py-16 sm:py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-dark mb-4 px-2">
            Zonas de servicio en Vic y Osona
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto px-4">
            Ofrecemos nuestros servicios de <strong>vaciado de pisos</strong>, <strong>vaciado de locales</strong>, <strong>limpieza por síndrome de Diógenes</strong> y <strong>retirada de muebles y electrodomésticos</strong> en Vic y toda la comarca de Osona. Servicio urgente disponible 24 horas.
          </p>
        </div>

        <nav className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-10 sm:mb-12 px-2" aria-label="Zonas de servicio">
          {areas.map((area, index) => (
            <span
              key={index}
              className="px-3 sm:px-5 py-2 sm:py-2.5 bg-secondary/10 text-dark rounded-full text-xs sm:text-sm font-medium hover:bg-primary hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              {area}
            </span>
          ))}
        </nav>

        <div className="bg-gradient-to-br from-secondary/5 to-primary/5 rounded-lg p-6 sm:p-8 text-center mx-2">
          <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-primary rounded-full mx-auto mb-4 flex-shrink-0">
            <i className="ri-map-pin-line text-2xl sm:text-3xl text-white" aria-hidden="true"></i>
          </div>
          <h3 className="text-lg sm:text-xl font-bold text-dark mb-3 break-words px-2">
            ¿No encuentras tu zona?
          </h3>
          <p className="text-sm text-gray-600 mb-6 max-w-2xl mx-auto break-words px-2">
            También trabajamos en otras localidades de la comarca de Osona y alrededores. Consúltanos sin compromiso y te informaremos sobre la disponibilidad de nuestros servicios en tu zona.
          </p>
          <a
            href="tel:+34602365996"
            className="inline-block bg-primary text-white px-6 sm:px-8 py-3 rounded-lg font-semibold hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm cursor-pointer"
            aria-label="Llamar para consultar disponibilidad"
          >
            <i className="ri-phone-line mr-2" aria-hidden="true"></i>
            Consultar disponibilidad
          </a>
        </div>
      </div>
    </section>
  );
}
